;
const RadianConversionRatio = Math.PI / 180;
const MaxPoints = 10;
const Padding = MaxPoints * 4;
const MidWayPoint = { x: MaxPoints, y: MaxPoints };
export const getPointCoordinates = (radius, nthPoint, numPoints) => {
    const radians = RadianConversionRatio * ((360 / numPoints) * nthPoint - 90);
    const x = radius * Math.cos(radians);
    const y = radius * Math.sin(radians);
    return { x, y };
};
export const inBetween = (point1, point2) => {
    const intermediatePointX = Math.abs(point1.x - point2.x) / 2 + Math.min(point1.x, point2.x);
    const intermediatePointY = Math.abs(point1.y - point2.y) / 2 + Math.min(point1.y, point2.y);
    return { x: intermediatePointX, y: intermediatePointY };
};
export const getAttrPath = (monster, attributeKeyOrder, dimensions) => {
    dimensions -= (Padding * 2);
    const path = [];
    let lastPoint;
    attributeKeyOrder.forEach((key, idx) => {
        const radius = monster.serialized.baseAttributes[key];
        const { x, y } = getPointCoordinates(radius, idx, attributeKeyOrder.length);
        const coordFromOrigin = { x: x + MaxPoints, y: y + MaxPoints };
        if (lastPoint) {
            const midway = inBetween(lastPoint, coordFromOrigin);
            const midwayPulledIn = inBetween(midway, MidWayPoint);
            path.push({ x: midwayPulledIn.x, y: midwayPulledIn.y });
        }
        lastPoint = coordFromOrigin;
        path.push(coordFromOrigin);
    });
    const midway = inBetween(lastPoint, path[0]);
    const midwayPulledIn = inBetween(midway, MidWayPoint);
    path.push({ x: midwayPulledIn.x, y: midwayPulledIn.y });
    let pathStr = '';
    const dimensionsRatio = dimensions / (MaxPoints * 2);
    path.forEach(({ x, y }) => {
        if (pathStr === '') {
            pathStr += 'M ';
        }
        else {
            pathStr += 'L ';
        }
        pathStr += `${x * dimensionsRatio + Padding} `;
        pathStr += `${y * dimensionsRatio + Padding} `;
    });
    pathStr += 'Z';
    return {
        d: pathStr,
        fill: 'black',
        stroke: 'black',
    };
};
export const getAttrScalePath = (monster, attributeKeyOrder, dimensions) => {
    dimensions -= (Padding * 2);
    const path = [];
    attributeKeyOrder.forEach((key, idx) => {
        const { x, y } = getPointCoordinates(MaxPoints, idx, attributeKeyOrder.length);
        const coordFromOrigin = { x: x + MaxPoints, y: y + MaxPoints };
        path.push(coordFromOrigin);
        path.push(MidWayPoint);
    });
    let pathStr = '';
    const dimensionsRatio = dimensions / (MaxPoints * 2);
    path.forEach(({ x, y }) => {
        if (pathStr === '') {
            pathStr += 'M ';
        }
        else {
            pathStr += 'L ';
        }
        pathStr += `${x * dimensionsRatio + Padding} `;
        pathStr += `${y * dimensionsRatio + Padding} `;
    });
    pathStr += 'Z';
    return {
        d: pathStr,
        stroke: 'black',
        fill: 'black',
    };
};
const attackPath = [
    { x: 1, y: 5 },
    { x: 2, y: 4 },
    { x: 3, y: 6 },
    { x: 7, y: 1 },
    { x: 9, y: 1 },
    { x: 9, y: 3 },
    { x: 4, y: 7 },
    { x: 6, y: 8 },
    { x: 5, y: 9 },
    { x: 3.5, y: 7.5 },
    { x: 2, y: 9 },
    { x: 1, y: 8 },
    { x: 2.5, y: 6.5 },
].map(({ x, y }) => x === null ? { x, y } : ({ x: (x - 5) * (MaxPoints / 5), y: (y - 5) * (MaxPoints / 5) }));
const defensePath = [
    { x: 1, y: 1 },
    { x: 9, y: 1 },
    { x: 9, y: 4 },
    { x: 8, y: 7 },
    { x: 5, y: 9 },
    { x: 2, y: 7 },
    { x: 1, y: 4 },
].map(({ x, y }) => x === null ? { x, y } : ({ x: (x - 5) * (MaxPoints / 5), y: (y - 5) * (MaxPoints / 5) }));
const magicPath = [
    { x: 1, y: 4 },
    { x: 4, y: 4 },
    { x: 5, y: 1 },
    { x: 6, y: 4 },
    { x: 9, y: 4 },
    { x: 7, y: 6 },
    { x: 8, y: 9 },
    { x: 5, y: 7 },
    { x: 2, y: 9 },
    { x: 3, y: 6 },
].map(({ x, y }) => x === null ? { x, y } : ({ x: (x - 5) * (MaxPoints / 5), y: (y - 5) * (MaxPoints / 5) }));
const healthPath = [
    { x: 2, y: 1 },
    { x: 3, y: 1 },
    { x: 5, y: 3 },
    { x: 7, y: 1 },
    { x: 8, y: 1 },
    { x: 9, y: 2 },
    { x: 9, y: 4 },
    { x: 7, y: 7 },
    { x: 5, y: 9 },
    { x: 3, y: 7 },
    { x: 1, y: 4 },
    { x: 1, y: 2 },
].map(({ x, y }) => x === null ? { x, y } : ({ x: (x - 5) * (MaxPoints / 5), y: (y - 5) * (MaxPoints / 5) }));
const manaPath = [
    { x: 4, y: 1 },
    { x: 6, y: 1 },
    { x: 6, y: 3 },
    { x: 8, y: 4 },
    { x: 9, y: 6 },
    { x: 8.5, y: 8 },
    { x: 8, y: 9 },
    { x: 5, y: 9.5 },
    { x: 2, y: 9 },
    { x: 1.5, y: 8 },
    { x: 1, y: 6 },
    { x: 2, y: 4 },
    { x: 4, y: 3 },
].map(({ x, y }) => x === null ? { x, y } : ({ x: (x - 5) * (MaxPoints / 5), y: (y - 5) * (MaxPoints / 5) }));
const speedPath = [
    { x: 6, y: 1 },
    { x: 8, y: 3 },
    { x: 5, y: 5 },
    { x: 9, y: 5 },
    { x: 3, y: 9 },
    { x: 5, y: 6 },
    { x: 3, y: 6 },
].map(({ x, y }) => x === null ? { x, y } : ({ x: (x - 5) * (MaxPoints / 5), y: (y - 5) * (MaxPoints / 5) }));
const luckPath = [
    { x: 4.5, y: 8.5 },
    { x: 5.5, y: 8.5 },
    { x: 5.5, y: 9.5 },
    { x: 4.5, y: 9.5 },
    { x: null, y: null },
    { x: 4.5, y: 7.5 },
    { x: 4.5, y: 5 },
    { x: 6.5, y: 3.5 },
    { x: 6.5, y: 2.5 },
    { x: 6, y: 1.5 },
    { x: 4, y: 1.5 },
    { x: 3, y: 2.5 },
    { x: 3, y: 3.5 },
    { x: 2, y: 3.5 },
    { x: 3.5, y: 0.5 },
    { x: 6.5, y: 0.5 },
    { x: 7.5, y: 2.5 },
    { x: 7.5, y: 3.5 },
    { x: 5.5, y: 5 },
    { x: 5.5, y: 7.5 },
].map(({ x, y }) => x === null ? { x, y } : ({ x: (x - 5) * (MaxPoints / 5), y: (y - 5) * (MaxPoints / 5) }));
export const getPathFor = (path) => (center, dimensions) => {
    let pathStr = '';
    const dimensionsRatio = dimensions / (MaxPoints * 2);
    let moveTo = false;
    path
        .map(({ x, y }) => ({ x: x === null ? null : x + center.x, y: y === null ? null : y + center.y }))
        .forEach(({ x, y }) => {
        if (x === null && y === null) {
            moveTo = true;
            pathStr += 'Z ';
        }
        else {
            if (moveTo || pathStr === '') {
                moveTo = false;
                pathStr += 'M ';
            }
            else {
                pathStr += 'L ';
            }
            pathStr += `${x * dimensionsRatio} `;
            pathStr += `${y * dimensionsRatio} `;
        }
    });
    pathStr += 'Z ';
    return pathStr;
};
const pathMaps = {
    attack: getPathFor(attackPath),
    defense: getPathFor(defensePath),
    health: getPathFor(healthPath),
    mana: getPathFor(manaPath),
    magic: getPathFor(magicPath),
    speed: getPathFor(speedPath),
    luck: getPathFor(luckPath),
};
const getIconPath = (center, key, dimensions) => {
    return pathMaps[key](center, dimensions);
};
export const getAttrIcon = (monster, key, nthKey, dimensions) => {
    dimensions -= (Padding * 2);
    const { x, y } = getPointCoordinates(MaxPoints + (MaxPoints / 5), nthKey, Object.keys(monster.serialized.baseAttributes).length);
    const dimensionsRatio = dimensions / (MaxPoints * 2);
    const center = { x: ((x + MaxPoints) * dimensionsRatio) + Padding, y: ((y + MaxPoints) * dimensionsRatio) + Padding };
    const pathStr = getIconPath(center, key, Padding / 2);
    return {
        d: pathStr,
        stroke: 'black',
        fill: 'black',
    };
};
